import { Box, Card, styled } from '@treneo/shared/ui';

export const OrganizationsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
`;

export const StyledOrganizationCard = styled(Card)`
  margin: 8px;
  flex: 1;
  min-width: 300px;
  max-width: 400px;
`;
